import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration } from 'chart.js';

interface TrafficData {
  hour?: number;
  day?: string;
  location?: string;
  count: number;
}

@Component({
  selector: 'app-traffic',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatTabsModule,
    MatIconModule,
    BaseChartDirective
  ],
  templateUrl: './traffic.component.html',
  styleUrl: './traffic.component.scss'
})
export class TrafficComponent implements OnInit {
  // Дані по годинах
  hourlyTraffic: TrafficData[] = [];
  hourlyChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: []
  };
  hourlyChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false }
    },
    scales: {
      y: { beginAtZero: true }
    }
  };

  // Дані по днях
  dailyTraffic: TrafficData[] = [];
  dailyChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: []
  };

  // Дані по локаціях
  locationTraffic: TrafficData[] = [];
  locationColumns: string[] = ['location', 'count', 'percentage'];

  ngOnInit(): void {
    this.loadHourlyTraffic();
    this.loadDailyTraffic();
    this.loadLocationTraffic();
  }

  loadHourlyTraffic(): void {
    // Демо дані - трафік по годинах за сьогодні
    const hours = Array.from({ length: 24 }, (_, i) => i);
    this.hourlyTraffic = hours.map(hour => ({
      hour,
      count: Math.floor(Math.random() * 50) + 10
    }));

    this.hourlyChartData = {
      labels: hours.map(h => `${h}:00`),
      datasets: [{
        label: 'Кількість авто',
        data: this.hourlyTraffic.map(t => t.count),
        backgroundColor: 'rgba(123, 104, 238, 0.5)',
        borderColor: 'rgba(123, 104, 238, 1)',
        borderWidth: 2
      }]
    };
  }

  loadDailyTraffic(): void {
    // Демо дані - трафік по днях за останній тиждень
    const days = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];
    this.dailyTraffic = days.map(day => ({
      day,
      count: Math.floor(Math.random() * 300) + 100
    }));

    this.dailyChartData = {
      labels: days,
      datasets: [{
        label: 'Кількість авто',
        data: this.dailyTraffic.map(t => t.count),
        backgroundColor: 'rgba(34, 197, 94, 0.5)',
        borderColor: 'rgba(34, 197, 94, 1)',
        borderWidth: 2
      }]
    };
  }

  loadLocationTraffic(): void {
    // Демо дані - трафік по точках проїзду
    this.locationTraffic = [
      { location: "В'їзд Головний", count: 856 },
      { location: "В'їзд Бічний", count: 432 },
      { location: "Виїзд Головний", count: 789 },
      { location: "Виїзд Бічний", count: 398 },
      { location: 'Шлагбаум A', count: 567 },
      { location: 'Шлагбаум B', count: 321 }
    ];
  }

  getPercentage(count: number): number {
    const total = this.locationTraffic.reduce((sum, t) => sum + t.count, 0);
    return Math.round((count / total) * 100);
  }
}
